export default "__VITE_ASSET__B0Ldq8iX__"